module.exports = __webpack_public_path__ + "static/background-068d850c71443371809c98db783fec9a.png";